import * as React from "react";
const SvgFiRrTransformationShapes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-transformation-shapes_svg__a)">
      <path
        fill="#062147"
        d="M6.5 0A6.51 6.51 0 0 0 0 6.5C0 10.084 2.916 13 6.5 13S13 10.084 13 6.5 10.084 0 6.5 0m0 11A4.506 4.506 0 0 1 2 6.5C2 4.02 4.019 2 6.5 2S11 4.02 11 6.5 8.981 11 6.5 11M20 12h-4c-2.206 0-4 1.794-4 4v4c0 2.206 1.794 4 4 4h4c2.206 0 4-1.794 4-4v-4c0-2.206-1.794-4-4-4m2 8c0 1.103-.897 2-2 2h-4c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2zM8.433 18.607c.761.762.761 2.023-.013 2.798l-2.199 2.288a.997.997 0 0 1-1.414.028 1 1 0 0 1-.027-1.414L6.036 21H4.001c-2.206 0-4-1.794-4-4v-2a1 1 0 1 1 2 0v2c0 1.103.897 2 2 2H6.03l-1.25-1.307a1 1 0 0 1 1.441-1.387zM24 7v2a1 1 0 1 1-2 0V7c0-1.103-.897-2-2-2h-2.029l1.25 1.307a1 1 0 0 1-1.441 1.386l-2.212-2.3c-.761-.763-.761-2.024.013-2.799L17.78.306a1 1 0 0 1 1.441 1.387L17.965 3H20c2.206 0 4 1.794 4 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-transformation-shapes_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTransformationShapes;
